export default __webpack_public_path__ + "static/media/cases-01-thumbnail.c353a572.jpg";